import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {
      id: '',
      name: '',
      phone: '',
      email: '',
      avatar: ''
    },
    myStations: [],
    currentLocation: {
      latitude: null,
      longitude: null,
      address: ''
    }
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = { ...state.userInfo, ...userInfo }
    },
    SET_MY_STATIONS(state, stations) {
      state.myStations = stations
    },
    ADD_STATION(state, station) {
      state.myStations.unshift(station)
    },
    SET_CURRENT_LOCATION(state, location) {
      state.currentLocation = { ...state.currentLocation, ...location }
    }
  },
  actions: {
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },
    setMyStations({ commit }, stations) {
      commit('SET_MY_STATIONS', stations)
    },
    addStation({ commit }, station) {
      commit('ADD_STATION', station)
    },
    setCurrentLocation({ commit }, location) {
      commit('SET_CURRENT_LOCATION', location)
    }
  },
  getters: {
    getUserInfo: state => state.userInfo,
    getMyStations: state => state.myStations,
    getCurrentLocation: state => state.currentLocation
  }
})